module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"only one asset allowed":"Legen Sie hier nicht mehr als eine Datei ab."}}')
  delete Component.options._Ctor
}
